import Vue from 'vue'
import CamelCase from './CamelCase'
import moment from 'moment'

const camelCase = new CamelCase()

const getDateTime = function (date) {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
}

export default {
  setSetting(state, { chatUrl, chatPort, chatProvider }) {
    state.provider.chat.url = chatUrl
    state.provider.chat.port = chatPort
    state.provider.crm.name = chatProvider
  },
  clearChatDat(state) {
    state.offset = 0
    state.quantityUsers = 30
    state.users = []
    state.chatList.forEach(chat => {
      chat.messages = []
    })
    Vue.set(state, 'chatList', state.chatList)
  },
  setActiveAnswerItem(state, data) {
    state.activeAnswerItem = data
    state.selectedMessages = []

    if (state.chatIdForForward !== null) {
      state.chatIdForForward = null
      state.forwardReadyMessages = []
    }
  },

  /**
   *
   * @param state
   * @return {Error|null}
   */
  getCrmToken(state) {
    const tokenCRM = (state.provider.crm.token = localStorage.getItem('token'))
    return tokenCRM ? state.provider.crm.token : new Error('CRM token not found. login to CRM or PlChat.')
  },

  /**
   *
   * @param state
   * @param destination
   * @param data
   */
  setProfile(state, { profile }) {
    for (const property in profile) {
      if (Object.prototype.hasOwnProperty.call(profile, property)) {
        state.profile[property] = profile[property]
      }
    }
  },
  setChatList(state, { chatList }) {
    chatList.forEach(chat => {
      const existingChat = state.chatList.find(oldChat => oldChat.id === chat.id)

      if (existingChat) {
        for (const property in chat) {
          if (Object.prototype.hasOwnProperty.call(chat, property)) {
            if (property === 'users') {
              this.commit('setMembersToChat', {
                data: chat.users,
                chatId: chat.id,
              })
            } else if (property === 'messages') {
              this.commit('setMessagesToChat', {
                chatId: chat.id,
                messageArray: chat.messages,
              })
            } else {
              existingChat[property] = chat[property]
            }
          }
        }
      } else {
        state.chatList.push(chat)
      }
    })

    state.chatList.sort((a, b) => {
      if (a.lastMessage && b.lastMessage) {
        if (a.lastMessage.updatedAt < b.lastMessage.updatedAt) return 1
        if (a.lastMessage.updatedAt === b.lastMessage.updatedAt) return 0
        if (a.lastMessage.updatedAt > b.lastMessage.updatedAt) return -1
      } else if (a.lastMessage && !b.lastMessage) {
        if (a.lastMessage.updatedAt < b.updatedAt) return 1
        if (a.lastMessage.updatedAt === b.updatedAt) return 0
        if (a.lastMessage.updatedAt > b.updatedAt) return -1
      } else if (!a.lastMessage && b.lastMessage) {
        if (a.updatedAt < b.lastMessage.updatedAt) return 1
        if (a.updatedAt === b.lastMessage.updatedAt) return 0
        if (a.updatedAt > b.lastMessage.updatedAt) return -1
      } else if (!a.lastMessage && !b.lastMessage) {
        if (a.updatedAt < b.updatedAt) return 1
        if (a.updatedAt === b.updatedAt) return 0
        if (a.updatedAt > b.updatedAt) return -1
      }
    })
  },
  changeDataInTargetChatItem(state, newData) {
    const indexInList = state.chatList.findIndex(chat => chat.id === newData.id)

    Vue.set(state.chatList, indexInList, newData)
  },
  setUsers(state, { data, search }) {
    let users = state.users

    if (!search) {
      data.forEach(user => {
        const userExist = state.users.find(u => u.id === user.id)

        if (!userExist) {
          users.push(user)
        }
      })
    } else {
      users = data
    }

    Vue.set(state, 'users', users)
  },

  setIdMembersPrivateChats(state) {
    const privateChatWithMembers = state.chatList.filter(chat => chat.type === 'private' && !!chat.users)
    const idsMembersPrivateChat = new Set()

    idsMembersPrivateChat.add(state.profile.id)
    privateChatWithMembers.forEach(chat => {
      chat.users.forEach(member => idsMembersPrivateChat.add(member.id))
    })
    Vue.set(state, 'idsMembersPrivateChat', idsMembersPrivateChat)
  },

  /**
   *
   * @param state
   * @param data
   */
  setCredential(state, data) {
    state.provider.chat.token = data.token
    localStorage.setItem('tokenChat', state.provider.chat.token)
  },

  getTokenInLocalStorage(state, itemName) {
    state.provider.chat.token = localStorage.getItem(itemName)
    return state.provider.chat.token
  },
  //todo ok
  setMessagesToChat(state, { chatId, messageArray, nextMessagePage }) {
    // передавать id чата
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    if (!state.chatList[chatIndex].hasOwnProperty('messages') || !state.chatList[chatIndex].messages.length) {
      state.chatList[chatIndex].messages = messageArray
    } else {
      messageArray.forEach(newMessage => {
        const existingMessage = state.chatList[chatIndex].messages.find(exMessage => exMessage.id === newMessage.id)

        if (existingMessage) {
          for (const property in newMessage) {
            if (Object.prototype.hasOwnProperty.call(newMessage, property)) {
              existingMessage[property] = newMessage[property]
            }
          }
        } else {
          state.chatList[chatIndex].messages.push(newMessage)
        }
      })
    }

    state.chatList[chatIndex].nextMessagePage = nextMessagePage
    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  addMessageToChat(state, { message, chatId }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    state.chatList[chatIndex] = {
      ...state.chatList[chatIndex],
      messages: [message, ...(state.chatList[chatIndex]?.messages || [])],
      lastMessage: {
        updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
      },
    }

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  deleteMessage(state, { messageId, chatId }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    state.chatList[chatIndex].messages = state.chatList[chatIndex].messages.filter(
      messageItem => messageItem.id !== messageId,
    )

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  setMembersToChat(state, { data, chatId }) {
    if (data.length) {
      state.chatList.forEach(chat => {
        if (chat.id === chatId) {
          if (!chat.hasOwnProperty('users')) {
            chat.users = data
          } else {
            chat.users.forEach(member => {
              data.forEach(newMemberStatus => {
                if (member.id === newMemberStatus.id) {
                  for (const property in member) {
                    if (Object.prototype.hasOwnProperty.call(member, property)) {
                      member[property] = newMemberStatus[property]
                    }
                  }
                }
              })
            })
          }
        }
      })

      Vue.set(state, 'chatList', state.chatList)
    }
  },
  addMembersToChat(state, { userId, chatId, chatType = null }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)
    const user = state.users.find(user => user.id === userId)

    state.chatList[chatIndex].users.push(user)
    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])

    return state.chatList[chatIndex].users
  },
  removeMembersToChat(state, { userId, chatId }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)
    const indexMember = state.chatList[chatIndex].users.findIndex(member => member.id === userId)

    state.chatList[chatIndex].users.splice(indexMember, 1)
    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])

    return state.chatList[chatIndex].users
  },
  setNewChat(state, { chatType }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === -1)
    const chatItem = {
      id: -1,
      name: '',
      icon: '',
      type: chatType,
      create: null,
      endMessageTime: null,
      users: [],
      messages: [],
      authorId: null,
      closedAt: '',
      createdAt: '',
      deletedAt: '',
      deletedBy: '',
      lastMessage: '',
      updatedAt: '',
      usersCount: '',
    }

    if (state.chatList[chatIndex]) {
      state.chatList[chatIndex] = chatItem
    } else {
      state.chatList.push(chatItem)
    }

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  // todo ok
  setChatName(state, { value, chatId }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    state.chatList[chatIndex].name = value

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  setChatIcon(state, { value, chatId }) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    state.chatList[chatIndex].icon = value
    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  //todo добавить сохпранение типа выбранного полчя в асайде, user || chat
  setPrevious(state, { id, type }) {
    state.previous.id = id
    state.previous.type = type //todo добавить здесь
  },
  setActiveChatData(state, data) {
    state.activeChat = data
  },
  saveChat(state, data) {
    const indexChatExists = state.chatList.findIndex(chat => chat.id === data.id)

    if (indexChatExists === -1) {
      if (!data.hasOwnProperty('users')) {
        data.users = []
      }
      if (!data.hasOwnProperty('messages')) {
        data.messages = []
      }
      state.chatList.push(data)
    }

    Vue.set(state, 'chatList', state.chatList)
  },

  removeChat(state, id) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === id)

    state.chatList.splice(chatIndex, 1)
  },
  setMessages(state, data) {
    state.activeChat.messages = data
  },
  addMessageToSelected(state, message) {
    state.selectedMessages.push(message)
  },
  removeMessageFromSelected(state, messageId) {
    const index = state.selectedMessages.findIndex(item => item.id === messageId)

    state.selectedMessages.splice(index, 1)
  },
  clearSelectedMessages(state) {
    state.selectedMessages = []
  },
  setChatIdForForward(state, value) {
    state.chatIdForForward = value
    state.forwardReadyMessages = [...state.selectedMessages]
    state.activeAnswerItem = {}

    if (value === null) {
      state.selectedMessages = []
    }
  },
  setChoiceForwardIsActive(state, value) {
    state.choiceForwardIsActive = value
  },
  setEditMessage(state, message) {
    state.editMessage = message
  },
  setEditingMessage(state, updatedMessage) {
    const { id, chatId } = updatedMessage
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    state.chatList[chatIndex].messages = state.chatList[chatIndex].messages.map(message => {
      if (message.id === id) {
        message = updatedMessage
      }

      return message
    })

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  removeNotifyNewMessage(state, chatId) {
    const chatIndex = state.chatList.findIndex(chat => chat.id === chatId)

    if (state.chatList[chatIndex]) {
      state.chatList[chatIndex].newMessageNotify = false
      Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
    }
  },
  setOffset(state, value) {
    if (value && Number.isInteger(value) && value > 0) {
      state.offset = state.offset + value
    } else {
      state.offset = 0
    }
  },
  clearUsers(state) {
    Vue.set(state, 'users', [])
  },
  setImagesGallery(state, data) {
    state.imagesGallery = data
  },
  setLastChatPage(state, value) {
    state.lastChatPage = value
  },
  async SOCKET_newMessage(state, { data, activeChatId, openedChat }) {
    const message = camelCase.keysToCamel(data.message)
    const chatIndex = state.chatList.findIndex(chat => chat.id === message.chatId)

    if (state.chatList[chatIndex].hasOwnProperty('messages')) {
      const messageExist = state.chatList[chatIndex].messages.find(mes => mes.id === message.id)

      if (!messageExist) {
        state.chatList[chatIndex].messages.unshift(message)
      }
    } else {
      state.chatList[chatIndex].messages = []
      state.chatList[chatIndex].messages.unshift(message)
    }

    if (!openedChat) {
      state.chatList[chatIndex].newMessageNotify = true
    } else {
      state.chatList[chatIndex].newMessageNotify = state.chatList[chatIndex].id !== activeChatId && openedChat
    }

    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
  SOCKET_updateMessage(state, data) {
    const message = camelCase.keysToCamel(data)

    this.commit('setEditingMessage', message)
  },
  SOCKET_deleteMessage(state, data) {
    const message = camelCase.keysToCamel(data)
    const chatIndex = state.chatList.findIndex(chat => chat.id === message.chatId)

    this.commit('deleteMessage', {
      message: message,
      messageId: message.id,
      chatId: message.chatId,
    })
    Vue.set(state.chatList, chatIndex, state.chatList[chatIndex])
  },
}
